import { create } from "zustand";
import { persist } from "zustand/middleware";

interface FiltersState {
  filterGender: any[];
  filterSubscriptionStatus: any[];
  filterSubscriptionType: any[];
  isProd: boolean;
  completedDaysPercentageMin: number | null;
  completedDaysPercentageMax: number | null;

  setFilterGender: (values: any[]) => void;
  setFilterSubscriptionStatus: (values: any[]) => void;
  setFilterSubscriptionType: (values: any[]) => void;
  setIsProd: (value: boolean) => void;
  setCompletedDaysPercentageMin: (value: number | null) => void;
  setCompletedDaysPercentageMax: (value: number | null) => void;
  search: string;
  setSearch: (value: string) => void;

  // Sort states
  nameSort: number;
  genderSort: number;
  emailSort: number;
  cancellationDateSort: number;
  dateSort: number;
  compDaysSort: number;
  completedDaysPercentageSort: number;
  subscriptionStatusSort: number;
  subscriptionTypeSort: number;

  setNameSort: (value: number) => void;
  setGenderSort: (value: number) => void;
  setEmailSort: (value: number) => void;
  setCancellationDateSort: (value: number) => void;
  setDateSort: (value: number) => void;
  setCompDaysSort: (value: number) => void;
  setCompletedDaysPercentageSort: (value: number) => void;
  setSubscriptionStatusSort: (value: number) => void;
  setSubscriptionTypeSort: (value: number) => void;
}

export const useFiltersStore = create<FiltersState>()(
  persist(
    (set) => ({
      filterGender: [],
      filterSubscriptionStatus: [],
      filterSubscriptionType: [],
      isProd: true,
      completedDaysPercentageMin: null,
      completedDaysPercentageMax: null,

      setFilterGender: (values: any[]) => set({ filterGender: values }),

      setFilterSubscriptionStatus: (values: any[]) =>
        set({
          filterSubscriptionStatus: values,
        }),
      search: "",
      setSearch: (value: string) => set({ search: value }),
      setFilterSubscriptionType: (values: any[]) =>
        set({
          filterSubscriptionType: values,
        }),

      setIsProd: (value: boolean) => set({ isProd: value }),
      setCompletedDaysPercentageMin: (value: number | null) =>
        set({ completedDaysPercentageMin: value }),
      setCompletedDaysPercentageMax: (value: number | null) =>
        set({ completedDaysPercentageMax: value }),

      // Sort states
      nameSort: 0,
      genderSort: 0,
      emailSort: 0,
      cancellationDateSort: 0,
      dateSort: 0,
      compDaysSort: 0,
      completedDaysPercentageSort: 0,
      subscriptionStatusSort: 0,
      subscriptionTypeSort: 0,

      setNameSort: (value: number) => set({ nameSort: value }),
      setGenderSort: (value: number) => set({ genderSort: value }),
      setEmailSort: (value: number) => set({ emailSort: value }),
      setCancellationDateSort: (value: number) =>
        set({ cancellationDateSort: value }),
      setDateSort: (value: number) => set({ dateSort: value }),
      setCompDaysSort: (value: number) => set({ compDaysSort: value }),
      setCompletedDaysPercentageSort: (value: number) =>
        set({ completedDaysPercentageSort: value }),
      setSubscriptionStatusSort: (value: number) =>
        set({ subscriptionStatusSort: value }),
      setSubscriptionTypeSort: (value: number) =>
        set({ subscriptionTypeSort: value }),
    }),
    {
      name: "user-filters-storage", // unique name for localStorage key
    }
  )
);
